import { I18n } from '@calendly/i18n';
import { Control, Option, Options, Select } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { OptionBody } from './option_body';

// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.dividers.most_popular")
// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.location.dropdown.dividers.other")
const dividerCss = "dzwfv1y";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    value,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)}>
      {I18n.t(`publisher.event_type_editor.sections.event_details.location.dropdown.dividers.${value}`)}
    </Component>;
});
export const LocationSelect = ({
  onChange,
  isDisabled = false,
  availableKinds,
  placeholder = I18n.t('publisher.event_type_editor.sections.event_details.location.dropdown.placeholder'),
  startExpanded = false,
  ...props
}) => <Select onChange={onChange} disabled={isDisabled} expanded={startExpanded} {...props}>
    <Control aria-label={placeholder} placeholder={placeholder} />
    <Options>
      {availableKinds.map(({
      type,
      value
    }) => type === 'divider' ? <Divider key={value} value={value} /> : <Option key={value} value={value}>
          <OptionBody value={value} />
        </Option>)}
    </Options>
  </Select>;

require("./location_select.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_select.js");